import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const MessageActions = React.memo(({
  messageId,
  onFeedback,
  feedbackGiven,
  copyFeedback,
  onCopy
}) => {
  if (!messageId) return null;

  const hasBackendMessageId = messageId && typeof messageId === 'string' && !messageId.startsWith('msg_');
  const canGiveFeedback = hasBackendMessageId;

  return (
    <Box sx={{ 
      position: 'absolute',
      left: '0px',
      bottom: '-28px',
      display: 'flex',
      gap: 0.5,
      zIndex: 2,
    }}>
      <Tooltip title="Helpful">
        <IconButton
          size="small"
          onClick={() => onFeedback(messageId, true)}
          disabled={!canGiveFeedback || feedbackGiven[messageId]}
          color={feedbackGiven[messageId] === 'positive' ? 'primary' : 'default'}
          sx={{
            padding: '4px',
            opacity: !canGiveFeedback ? 0.5 : (feedbackGiven[messageId] ? (feedbackGiven[messageId] === 'positive' ? 1 : 0.5) : 0.7),
            bgcolor: 'background.paper',
            boxShadow: 1,
            '&:hover': {
              opacity: canGiveFeedback ? 1 : 0.5,
              bgcolor: canGiveFeedback ? 'primary.lighter' : 'background.paper',
            }
          }}
        >
          <ThumbUpIcon sx={{ fontSize: '16px' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Not Helpful">
        <IconButton
          size="small"
          onClick={() => onFeedback(messageId, false)}
          disabled={!canGiveFeedback || feedbackGiven[messageId]}
          color={feedbackGiven[messageId] === 'negative' ? 'error' : 'default'}
          sx={{
            padding: '4px',
            opacity: !canGiveFeedback ? 0.5 : (feedbackGiven[messageId] ? (feedbackGiven[messageId] === 'negative' ? 1 : 0.5) : 0.7),
            bgcolor: 'background.paper',
            boxShadow: 1,
            '&:hover': {
              opacity: canGiveFeedback ? 1 : 0.5,
              bgcolor: canGiveFeedback ? 'error.lighter' : 'background.paper',
            }
          }}
        >
          <ThumbDownIcon sx={{ fontSize: '16px' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title={copyFeedback[messageId] ? "Copied!" : "Copy response"}>
        <IconButton
          size="small"
          onClick={() => onCopy(messageId)}
          sx={{
            padding: '4px',
            opacity: copyFeedback[messageId] ? 1 : 0.7,
            bgcolor: 'background.paper',
            boxShadow: 1,
            color: copyFeedback[messageId] ? 'success.main' : 'text.secondary',
            '&:hover': {
              opacity: 1,
              bgcolor: 'action.hover',
            }
          }}
        >
          <ContentCopyIcon sx={{ fontSize: '16px' }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
});

export default MessageActions;

